/* eslint-disable */
import { createReducer, on, Action } from "@ngrx/store";
import * as Actions from "./reset-password.actions";

export const RESET_PASSWORD_FEATURE_KEY = "reset-password";

export interface ResetPasswordState {
    loading: boolean,
    succeeded: boolean,
    error: any | undefined,
}

export const initialAuthState: ResetPasswordState = {
    loading: false,
    succeeded: false,
    error: null,
};

const resetPasswordReducerInternal = createReducer(
    initialAuthState,
    on(Actions.resetPassword, (state, {token, password}) => {
        return {
            ...state,
            loading: false,
            succeeded: false,
            error: null,
        };
    }),
    on(Actions.complete, (state, {}) => {
        return {
            ...state,
            loading: false,
            succeeded: true,
            error: null,
        };
    }),
    on(Actions.failure, (state, {error}) => {
        return {
            ...state,
            loading: false,
            succeeded: false,
            error,
        };
    }),
    on(Actions.clearState, (state, {}) => {
        return {
            ...state,
            loading: false,
            succeeded: false,
            error: null,
        };
    }),
);

export function resetPasswordReducer(state: ResetPasswordState | undefined, action: Action) {
    return resetPasswordReducerInternal(state, action);
}
